import { isDefined } from '@sgme/fp';
import { apiConnector } from 'apiConnector/secondary-market/legacyApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
  secondaryMarketTradeFailed,
  secondaryMarketTradeReceived,
  secondaryMarketTradeRejected,
} from 'state/secondaryMarket/realtimeQuote/trade';
import type { EpicWithThunk } from 'state/state.common';

export function tradeRequestEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const { astroTrade: legacyTrade } = apiConnector(httpClient);
    return action$.pipe(
      ofType('SECONDARY_MARKET_TRADE_REQUESTED'),
      mergeMap(({ request, tabId, quoteId }) => {
        return legacyTrade(request).pipe(
          mergeMap(({ error, eventDate: tradeDate }) => {
            if (isDefined(error)) {
              return of(secondaryMarketTradeRejected(tabId, quoteId, error?.message));
            }
            return of(secondaryMarketTradeReceived(tabId, quoteId, tradeDate));
          }),
          catchError(error =>
            of(
              secondaryMarketTradeFailed(
                tabId,
                quoteId,
                error.payload ? `${error.message}: ${error.payload}` : error.message,
              ),
            ),
          ),
        );
      }),
    );
  };
}
